import { logger } from "@/logging";
import { ICanvasRenderer } from "./nodes/VideoCanvasNode";

const DEFAULT_WIDTH = 512;
const DEFAULT_HEIGHT = 512;
const OFFSCREEN_FALLBACK_DELAY = 500;

/**
 * Base class for canvas renderers with offscreen canvas fallback.
 * If setCanvas is not called within a timeout (e.g., encapsulated nodes with no UI),
 * creates an offscreen canvas automatically.
 */
export abstract class BaseRenderer implements ICanvasRenderer {
  protected canvas: HTMLCanvasElement | null = null;
  private fallbackTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    // Start timeout for offscreen fallback
  /*  this.fallbackTimeout = setTimeout(() => {
      if (!this.initialized) {
        this.createOffscreenCanvas();
      }
    }, OFFSCREEN_FALLBACK_DELAY);*/
  }


  //THIS IS DANEGROS AS WE CAN END UPO WITH LOTS OF UNNECESSARY RENDERING
  private createOffscreenCanvas(): void {
    logger.trace('BaseRenderer', 'creating offscreen canvas fallback');
    // Create a detached DOM canvas - OffscreenCanvas lacks 'style' which some renderers need
    const canvas = document.createElement('canvas');
    canvas.width = DEFAULT_WIDTH;
    canvas.height = DEFAULT_HEIGHT;
    this.canvas = canvas;
    this.initializeRenderer(canvas);

  }

  setCanvas(canvas: HTMLCanvasElement): void {
    // Cancel fallback timeout since UI provided a canvas
    if (this.fallbackTimeout) {
      clearTimeout(this.fallbackTimeout);
      this.fallbackTimeout = null;
    }

    this.canvas = canvas;
    this.initializeRenderer(canvas);

  }

  getCanvas(): HTMLCanvasElement | null {
    return this.canvas;
  }

  /**
   * Subclasses implement this to create their specific renderer (WebGL, Hydra, etc.)
   */
  protected abstract initializeRenderer(canvas: HTMLCanvasElement): void;

  // ─────────────────────────────────────────────────────────────
  // Before-render callbacks
  // ─────────────────────────────────────────────────────────────

  private beforeRenderCallbacks: ((dt?: number) => void)[] = [];

  addBeforeRender(cb: (dt?: number) => void): void {
    this.beforeRenderCallbacks.push(cb);
  }

  removeBeforeRender(cb: (dt?: number) => void): void {
    const idx = this.beforeRenderCallbacks.indexOf(cb);
    if (idx !== -1) this.beforeRenderCallbacks.splice(idx, 1);
  }

  /**
   * Runs all before-render callbacks, then the subclass render.
   * Callers invoke render(); subclasses implement doRender().
   */
  render(dt?: number): void {
    for (const cb of this.beforeRenderCallbacks) cb(dt);
    this._render(dt);
  }

  protected abstract _render(dt?: number): void;
  abstract setSize(width: number, height: number): void;

  dispose(): void {
    this.beforeRenderCallbacks.length = 0;
    if (this.fallbackTimeout) {
      clearTimeout(this.fallbackTimeout);
      this.fallbackTimeout = null;
    }
  }
}
